module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("underscore");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("draft-js");

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, EditorUtils, OutcomeTable, React, Translation, _, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

_ = __webpack_require__(2);

CustomRenderMixin = __webpack_require__(14);

Translation = __webpack_require__(5);

EditorUtils = __webpack_require__(7);

style = {
  font: {
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
  },
  footnotesList: {
    listStyle: 'lower-alpha'
  },
  sup: {
    marginLeft: '5px'
  }
};

OutcomeTable = React.createClass({
  displayName: 'OutcomeTable',
  propTypes: {
    data: object.isRequired
  },
  mixins: [CustomRenderMixin, Translation('es:outcome')],
  _getNormalizedFootnoteIndex: function(footnoteIndex) {
    var normalizedIndex;
    if (this.normalizedFootnotesOrder == null) {
      this.normalizedFootnotesOrder = [];
    }
    normalizedIndex = this.normalizedFootnotesOrder.indexOf(footnoteIndex);
    if (normalizedIndex < 0) {
      return this.normalizedFootnotesOrder.push(footnoteIndex);
    } else {
      return normalizedIndex + 1;
    }
  },
  getAlphabeticalSup: function(supString) {
    if (!supString) {
      return '';
    }
    return supString.split(' ').map((function(_this) {
      return function(num) {
        var normalizedIndex;
        normalizedIndex = _this._getNormalizedFootnoteIndex(Number.parseInt(num));
        return EditorUtils.numberToLetter(normalizedIndex);
      };
    })(this)).join(',');
  },
  renderCells: function(cells, references, headerCells) {
    if (references == null) {
      references = {};
    }
    if (headerCells == null) {
      headerCells = false;
    }
    return cells.map((function(_this) {
      return function(arg, idx) {
        var attributes, colspan, footnotesIndicesStr, name, ref, referenceIndicesStr, rowspan, sup, supText, textContent, type;
        colspan = arg.colspan, rowspan = arg.rowspan, textContent = arg.textContent, type = arg.type, name = arg.name, sup = arg.sup;
        if (type == null) {
          type = 'td';
        }
        referenceIndicesStr = ((ref = references[name]) != null ? ref : []).join(',');
        footnotesIndicesStr = _this.getAlphabeticalSup(sup);
        supText = _.isEmpty(referenceIndicesStr) || _.isEmpty(footnotesIndicesStr) ? referenceIndicesStr || footnotesIndicesStr : referenceIndicesStr + "," + footnotesIndicesStr;
        attributes = {
          name: name,
          rowSpan: rowspan,
          colSpan: colspan,
          key: idx,
          style: _.extend({}, _this.props.style.cell, _this.props.style[name], (headerCells ? _this.props.style.thCell : void 0))
        };
        return React.createElement(type, attributes, React.createElement('span', {
          dangerouslySetInnerHTML: {
            __html: textContent
          }
        }), React.createElement('sup', {
          style: style.sup
        }, supText));
      };
    })(this));
  },
  renderRows: function(rows, references, isHeader) {
    if (isHeader == null) {
      isHeader = false;
    }
    if (!rows) {
      return null;
    }
    return rows.map((function(_this) {
      return function(arg, idx) {
        var cells;
        cells = arg.cells;
        return React.createElement("tr", {
          "key": idx
        }, _this.renderCells(cells, references, isHeader));
      };
    })(this));
  },
  renderOutcomes: function() {
    var outcomes, ref, type;
    ref = this.props.data, type = ref.type, outcomes = ref.outcomes;
    if (type === 'diag') {
      return React.createElement("tbody", null, outcomes.map((function(_this) {
        return function(arg, idx) {
          var references, rows;
          rows = arg.rows, references = arg.references;
          return _this.renderRows(rows, references);
        };
      })(this)));
    } else {
      return outcomes.map((function(_this) {
        return function(arg, idx) {
          var references, rows;
          rows = arg.rows, references = arg.references;
          return React.createElement("tbody", {
            "key": idx
          }, _this.renderRows(rows, references));
        };
      })(this));
    }
  },
  renderFootnotes: function(footnotesList) {
    if (!footnotesList || _.isEmpty(this.normalizedFootnotesOrder)) {
      return null;
    }
    return React.createElement("ol", {
      "style": _.extend({}, style.font, style.footnotesList)
    }, this.normalizedFootnotesOrder.map(function(footnoteIdx, idx) {
      var note;
      if (!footnotesList[footnoteIdx - 1]) {
        return null;
      }
      note = footnotesList[footnoteIdx - 1].note;
      return React.createElement("li", {
        "key": idx
      }, note);
    }));
  },
  renderReferences: function(references) {
    if (_.isEmpty(references)) {
      return null;
    }
    return React.createElement("ol", {
      "style": style.font
    }, references.map(function(refText, idx) {
      return React.createElement("li", {
        "key": idx
      }, refText);
    }));
  },
  render: function() {
    var footnotesList, ref, references, thead;
    ref = this.props.data, thead = ref.thead, footnotesList = ref.footnotesList, references = ref.references;
    return React.createElement("div", null, React.createElement("table", {
      "style": this.props.style.table
    }, React.createElement("thead", {
      "style": this.props.style.thead
    }, this.renderRows(thead, null, true)), this.renderOutcomes()), this.renderReferences(references), this.renderFootnotes(footnotesList));
  }
});

module.exports = OutcomeTable;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var Translation, _string, createFragment;

_string = __webpack_require__(29);

createFragment = __webpack_require__(30);

Translation = function(namespace) {
  if (namespace == null) {
    namespace = '';
  }
  return {
    _i18n: function(key, params) {
      var keyWithNamespace, levelsToGoUp, namespaceTree, normalizedKey;
      if (params == null) {
        params = {};
      }
      keyWithNamespace = _string.startsWith(key, '/') ? key.slice(1) : _string.startsWith(key, '../') ? (namespaceTree = namespace.split(/\.|:/), namespaceTree.length === 1 ? key : (levelsToGoUp = key.match(/\.\.\//g).length, normalizedKey = key.replace(/\.\.\//g, ''), namespaceTree.slice(0, namespaceTree.length - levelsToGoUp).concat([normalizedKey]).join('.').replace('.', ':'))) : namespace.length ? namespace + "." + key : key;
      return $.t(keyWithNamespace, params);
    },
    i18n: function(key, params, componentParams) {
      var component, fragments, paramKey, replaceWithComponent, string;
      if (params == null) {
        params = {};
      }
      if (componentParams == null) {
        componentParams = null;
      }
      string = this._i18n(key, params);
      if (componentParams) {
        fragments = {};
        replaceWithComponent = function(string, key, component) {
          var split;
          split = string.split("__" + paramKey + "__");
          fragments["text_" + paramKey] = split[0];
          fragments["comp_" + paramKey] = component;
          return split[1];
        };
        for (paramKey in componentParams) {
          component = componentParams[paramKey];
          string = replaceWithComponent(string, paramKey, component);
        }
        fragments['last'] = string;
        return createFragment(fragments);
      } else {
        return string;
      }
    }
  };
};

module.exports = Translation;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("immutable");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var ALIGNMENT_STYLES, AtomicBlockUtils, BlockMapBuilder, CUSTOM_BLOCK_STYLES_CLASS_MAP, CUSTOM_STYLE_MAP, CharacterMetadata, CompositeDecorator, ContentBlock, ContentState, Draft, EditorState, Entity, Immutable, Link, Modifier, SelectionState, _, convertFromHTML, convertFromRaw, convertToRaw, elementToBlockSpecElement, gdtContentReplacer, gdtEditorUtils, genKey, getBlockSpecForElement, replaceElement, wrapBlockSpec,
  slice = [].slice;

Draft = __webpack_require__(3);

Immutable = __webpack_require__(6);

_ = __webpack_require__(2);

Link = __webpack_require__(31);

AtomicBlockUtils = Draft.AtomicBlockUtils, EditorState = Draft.EditorState, ContentState = Draft.ContentState, SelectionState = Draft.SelectionState, CompositeDecorator = Draft.CompositeDecorator, Entity = Draft.Entity, Modifier = Draft.Modifier, ContentBlock = Draft.ContentBlock, CharacterMetadata = Draft.CharacterMetadata, BlockMapBuilder = Draft.BlockMapBuilder, convertFromRaw = Draft.convertFromRaw, convertFromHTML = Draft.convertFromHTML, convertToRaw = Draft.convertToRaw, genKey = Draft.genKey;

CUSTOM_STYLE_MAP = {
  SMALL_FONT: {
    fontSize: '10px'
  },
  MODERATE_FONT: {
    fontSize: '12px'
  },
  NORMAL_FONT: {
    fontSize: '14px'
  },
  LARGE_FONT: {
    fontSize: '18px'
  },
  HUGE_FONT: {
    fontSize: '32px'
  }
};

CUSTOM_BLOCK_STYLES_CLASS_MAP = {
  'TEXT_ALIGN_LEFT': 'alignment--left',
  'TEXT_ALIGN_RIGHT': 'alignment--right',
  'TEXT_ALIGN_CENTER': 'alignment--center'
};

ALIGNMENT_STYLES = ['left', 'center', 'right'];

getBlockSpecForElement = function(el) {
  var content, gdtContentContainer, imgId, parent, type;
  switch (el.tagName.toLowerCase()) {
    case 'img':
      imgId = el.getAttribute('db-image');
      if (imgId == null) {
        return null;
      }
      return {
        contentType: 'image',
        imgId: imgId
      };
    case 'table':
      parent = el.parentNode;
      gdtContentContainer = parent.tagName.toLowerCase() === 'div' ? parent.classList.contains('inserted') ? parent : parent.classList.contains('outcomes-container') ? parent.parentNode : null : null;
      content = el.outerHTML.replace(/\n/g, '').replace(/(>)\s+(<)/g, '$1$2').replace(/\s\s+/g, ' ');
      if (gdtContentContainer != null) {
        type = gdtContentContainer.getAttribute('appendix-type');
        if (type == null) {
          return null;
        }
        return {
          contentType: 'gdt_table',
          type: type,
          content: content
        };
      } else {
        return {
          contentType: 'dangerousHTML',
          content: content
        };
      }
      break;
    default:
      return null;
  }
};

wrapBlockSpec = function(blockSpec) {
  var tempEl;
  if (blockSpec == null) {
    return null;
  }
  tempEl = document.createElement('blockquote');
  tempEl.innerText = JSON.stringify(blockSpec);
  return tempEl;
};

replaceElement = function(oldEl, newEl) {
  var parentNode;
  if (!(newEl instanceof HTMLElement)) {
    return;
  }
  parentNode = oldEl.parentNode;
  return parentNode.replaceChild(newEl, oldEl);
};

elementToBlockSpecElement = _.compose(wrapBlockSpec, getBlockSpecForElement);

gdtContentReplacer = function(gdtContentEl) {
  return replaceElement(gdtContentEl, elementToBlockSpecElement(gdtContentEl));
};

gdtEditorUtils = {
  CUSTOM_STYLE_MAP: CUSTOM_STYLE_MAP,
  CUSTOM_BLOCK_STYLES_CLASS_MAP: CUSTOM_BLOCK_STYLES_CLASS_MAP,
  rawContentBlocksToRawContent: _.compose(Immutable.fromJS, convertToRaw, ContentState.createFromBlockArray),
  openTableInNewWindow: function(tableTitle, tableHtml) {
    var el, tableContainer, tableWindowRef, title;
    tableWindowRef = null;
    tableWindowRef = window.open('about:blank', "_blank", 'resizable=yes, scrollable=yes, status=yes, menubar=no');
    if (tableWindowRef) {
      tableWindowRef.opener = null;
      el = document.createElement('div');
      title = document.createElement('h3');
      title.innerHTML = tableTitle;
      tableContainer = document.createElement('div');
      tableContainer.innerHTML = tableHtml;
      el.appendChild(title);
      el.appendChild(tableContainer);
      return tableWindowRef.document.write(el.innerHTML);
    }
  },
  getBlockRenderMap: function(customEntries) {
    var additionalEntries;
    additionalEntries = {
      section: {
        element: 'section'
      }
    };
    return Draft.DefaultDraftBlockRenderMap.merge(Immutable.Map(_.extend(additionalEntries, customEntries)));
  },
  findTextByEntityType: function(entityType) {
    return function(contentBlock, cb) {
      return contentBlock.findEntityRanges(function(char) {
        var entityKey;
        entityKey = char.getEntity();
        return (entityKey != null) && Entity.get(entityKey).getType() === entityType;
      }, cb);
    };
  },
  getEditorState: function(rawContent, customDecorators) {
    var contentState, decorators;
    decorators = gdtEditorUtils.getDecorators(customDecorators);
    if (typeof window === "undefined" || window === null) {
      return EditorState.createEmpty(decorators);
    }
    if (rawContent != null) {
      if (_.isString(rawContent)) {
        if (_.isEmpty(rawContent.trim())) {
          return EditorState.createEmpty(decorators);
        }
        rawContent = convertToRaw(gdtEditorUtils.customHTML2Content(rawContent));
      } else if (_.isObject(rawContent)) {
        if (rawContent.toJS != null) {
          rawContent = rawContent.toJS();
        }
      }
      contentState = convertFromRaw(rawContent);
      return EditorState.createWithContent(contentState, decorators);
    }
    return EditorState.createEmpty(decorators);
  },
  createContentBlock: function(blockData) {
    var blockSpec, charData, data, entityData, entityKey, inlineStyles, key, mutability, style, text, type;
    if (blockData == null) {
      blockData = {};
    }
    key = blockData.key, type = blockData.type, text = blockData.text, data = blockData.data, inlineStyles = blockData.inlineStyles, entityData = blockData.entityData;
    blockSpec = {
      type: type != null ? type : 'unstyled',
      text: text != null ? text : '',
      key: key != null ? key : genKey()
    };
    if (data) {
      blockSpec.data = Immutable.fromJS(data);
    }
    if (inlineStyles || entityData) {
      entityKey = entityData ? ((type = entityData.type, mutability = entityData.mutability, data = entityData.data, entityData), Entity.create(type, mutability, data)) : null;
      style = Immutable.OrderedSet(inlineStyles || []);
      charData = CharacterMetadata.create({
        style: style,
        entity: entityKey
      });
      blockSpec.characterList = Immutable.List(Immutable.Repeat(charData, text.length));
    }
    return new ContentBlock(blockSpec);
  },
  getSelectedBlocksList: function(editorState) {
    var blockAfter, currentContent, currentSelection, endBlock, endKey, selectedBlocks, startKey;
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    startKey = currentSelection.getStartKey();
    endKey = currentSelection.getEndKey();
    endBlock = currentContent.getBlockForKey(endKey);
    selectedBlocks = [].concat(currentContent.getBlockForKey(startKey));
    if (startKey === endKey) {
      return selectedBlocks;
    }
    while ((startKey !== endKey ? blockAfter = currentContent.getBlockAfter(startKey) : void 0) != null) {
      selectedBlocks = selectedBlocks.concat(blockAfter);
      startKey = blockAfter.getKey();
    }
    return selectedBlocks;
  },
  isBlockProtected: function(block) {
    if (block == null) {
      return false;
    }
    return block.getData().get('_isProtected');
  },
  willAlterProtectedBlock: function(editorState, command) {
    var block, blockAfter, blockBefore, currentContent, currentSelection, cursorAtBlockEnd, cursorAtBlockStart, isBlockProtected, startKey, startOffset;
    if (command !== 'input' && command !== 'delete' && command !== 'backspace' && command !== 'split-block' && command !== 'paste') {
      return false;
    }
    currentSelection = editorState.getSelection();
    isBlockProtected = gdtEditorUtils.isBlockProtected;
    if (currentSelection.isCollapsed()) {
      currentContent = editorState.getCurrentContent();
      startKey = currentSelection.getStartKey();
      block = currentContent.getBlockForKey(startKey);
      if (command === 'delete' || command === 'backspace') {
        if (isBlockProtected(block)) {
          return true;
        }
        startOffset = currentSelection.getStartOffset();
        cursorAtBlockStart = startOffset === 0;
        cursorAtBlockEnd = startOffset === block.getLength();
        if (!(cursorAtBlockStart || cursorAtBlockEnd)) {
          return isBlockProtected(block);
        }
        if (cursorAtBlockStart && command === 'backspace') {
          blockBefore = currentContent.getBlockBefore(startKey);
          return (blockBefore != null) && isBlockProtected(blockBefore);
        }
        if (cursorAtBlockEnd && command === 'delete') {
          blockAfter = currentContent.getBlockAfter(startKey);
          return (blockAfter != null) && isBlockProtected(blockAfter);
        }
        return false;
      } else {
        return isBlockProtected(block);
      }
    } else {
      return gdtEditorUtils.getSelectedBlocksList(editorState).some(isBlockProtected);
    }
  },
  clearAllStyles: function(editorState) {
    var blockMap, currentContent, currentSelection, endKey, endOffset, newContentState, startKey, startOffset, updatedBlocks;
    currentSelection = editorState.getSelection();
    currentContent = editorState.getCurrentContent();
    if (currentSelection.isCollapsed()) {
      return editorState;
    }
    blockMap = currentContent.getBlockMap();
    startKey = currentSelection.getStartKey();
    endKey = currentSelection.getEndKey();
    startOffset = currentSelection.getStartOffset();
    endOffset = currentSelection.getEndOffset();
    updatedBlocks = blockMap.skipUntil(function(v, k) {
      return k === startKey;
    }).takeUntil(function(v, k) {
      return k === endKey;
    }).concat(Immutable.Map([[endKey, blockMap.get(endKey)]])).map(function(block, blockKey) {
      var charIndexesToUpdate, rangeEnd, rangeStart, updatedChars;
      rangeStart = blockKey === startKey ? startOffset : 0;
      rangeEnd = blockKey === endKey ? endOffset : block.getLength() - 1;
      charIndexesToUpdate = Immutable.Range(rangeStart, rangeEnd + 1);
      updatedChars = block.getCharacterList().map(function(charData, idx) {
        var entity, ref;
        if (!charIndexesToUpdate.contains(idx)) {
          return charData;
        }
        entity = charData.getEntity();
        if (entity && ((ref = Entity.get(entity)) != null ? ref.get('type') : void 0) === 'LINK') {
          entity = null;
        }
        return CharacterMetadata.create({
          entity: entity
        });
      });
      if (block.getType() !== 'atomic') {
        block = block.set('type', 'unstyled');
      }
      return block.set('characterList', updatedChars);
    });
    newContentState = currentContent.merge({
      blockMap: blockMap.merge(updatedBlocks),
      selectionBefore: currentSelection,
      selectionAfter: currentSelection
    });
    return EditorState.push(editorState, newContentState);
  },
  splitBlock: function(editorState) {
    var newBlockKey, newBlockMap, newContent, originalBlockData;
    newContent = Modifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
    originalBlockData = newContent.blockMap.get(newContent.selectionBefore.getStartKey()).getData();
    newBlockKey = newContent.selectionAfter.getStartKey();
    newBlockMap = newContent.blockMap.update(newBlockKey, function(contentBlock) {
      return contentBlock.set('data', originalBlockData);
    });
    return EditorState.push(editorState, newContent.set('blockMap', newBlockMap), 'split-block');
  },
  deleteContent: function(editorState, command) {
    var block, blockAfter, blockBefore, currentBlockMap, currentContent, currentSelection, focusBlock, focusBlockLength, isBackspaceAndNoBlock, isDeleteAndNoBlock, newBlockMap, newContent, selectionAfter, startKey;
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    startKey = currentSelection.getStartKey();
    block = currentContent.getBlockForKey(startKey);
    blockAfter = currentContent.getBlockAfter(startKey);
    blockBefore = currentContent.getBlockBefore(startKey);
    if (currentSelection.isCollapsed()) {
      if (block.getLength() === 0 || block.getType() === 'atomic') {
        currentBlockMap = currentContent.getBlockMap();
        if (currentBlockMap.size === 1) {
          return gdtEditorUtils.flushEditorContent(editorState);
        }
        isDeleteAndNoBlock = command === 'delete' && !blockAfter;
        isBackspaceAndNoBlock = command === 'backspace' && !blockBefore;
        if (isDeleteAndNoBlock || isBackspaceAndNoBlock) {
          return null;
        }
        newBlockMap = currentBlockMap.filterNot(function(block) {
          return block.get('key') === startKey;
        });
        newContent = currentContent.set('blockMap', newBlockMap);
        focusBlock = command === 'delete' ? blockAfter : blockBefore;
        selectionAfter = SelectionState.createEmpty(focusBlock.getKey()).set('hasFocus', true);
        if (command === 'backspace') {
          focusBlockLength = focusBlock.getLength();
          selectionAfter = selectionAfter.merge({
            anchorOffset: focusBlockLength,
            focusOffset: focusBlockLength
          });
        }
        newContent = newContent.merge({
          selectionBefore: currentSelection,
          selectionAfter: selectionAfter
        });
        return EditorState.push(editorState, newContent, 'remove-range');
      } else {
        return null;
      }
    }
  },
  flushEditorContent: function(editorState) {
    var currentSelection, newContent, selectionAfter;
    currentSelection = editorState.getSelection();
    newContent = ContentState.createFromText('');
    selectionAfter = newContent.getSelectionAfter();
    return EditorState.push(editorState, newContent.merge({
      selectionBefore: currentSelection,
      selectionAfter: selectionAfter.set('hasFocus', true)
    }));
  },
  insertBlockContent: function(editorState, content) {
    var currentContent, currentSelection, newContentState, selectionAfter;
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    newContentState = Modifier.replaceWithFragment(currentContent, currentSelection, content.getBlockMap());
    selectionAfter = newContentState.getSelectionAfter();
    return EditorState.push(editorState, newContentState.merge({
      selectionBefore: currentSelection,
      selectionAfter: selectionAfter.set('hasFocus', true)
    }));
  },
  insertTextContent: function(editorState, text, entity) {
    var currentContent, currentSelection, data, entityKey, modifierAction, mutability, newContentState, selectionAfter, type;
    entityKey = null;
    if (entity != null) {
      type = entity.type, mutability = entity.mutability, data = entity.data;
      entityKey = Entity.create(type, mutability, data);
    }
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    modifierAction = currentSelection.isCollapsed() ? 'insertText' : 'replaceText';
    newContentState = Modifier[modifierAction](currentContent, currentSelection, text, null, entityKey);
    selectionAfter = newContentState.getSelectionAfter();
    return EditorState.push(editorState, newContentState.merge({
      selectionBefore: currentSelection,
      selectionAfter: selectionAfter.set('hasFocus', true)
    }));
  },
  isEditorFocused: function(editorState) {
    return editorState.getSelection().getHasFocus();
  },
  html2content: function(HTML) {
    var contentBlocks;
    contentBlocks = convertFromHTML(HTML);
    return ContentState.createFromBlockArray(contentBlocks);
  },
  customHTML2Content: function(HTML) {
    var contentBlocks, ref, tempDoc;
    HTML = HTML.replace(/(<\/?)(p|blockquote)/g, '$1section');
    tempDoc = new DOMParser().parseFromString(HTML, "text/html");
    _.union(_.toArray(tempDoc.querySelectorAll('img')), _.toArray(tempDoc.querySelectorAll('table'))).forEach(gdtContentReplacer);
    contentBlocks = convertFromHTML(tempDoc.body.innerHTML, void 0, gdtEditorUtils.getBlockRenderMap());
    contentBlocks = ((ref = contentBlocks.contentBlocks) != null ? ref : [gdtEditorUtils.createContentBlock()]).reduce(function(contentBlocks, block) {
      var atomicBlock, blockSpec, content, contentType, entityData, imgId, ref, spacerBlock, type;
      if (block.getType() !== 'blockquote') {
        return contentBlocks.concat(block);
      }
      ref = JSON.parse(block.getText()), contentType = ref.contentType, type = ref.type, imgId = ref.imgId, content = ref.content;
      entityData = (function() {
        switch (contentType) {
          case 'image':
            return {
              type: 'IMAGE',
              mutability: 'IMMUTABLE',
              data: {
                imageId: imgId
              }
            };
          case 'gdt_table':
            return {
              type: 'GDT_TABLE',
              mutability: 'IMMUTABLE',
              data: {
                type: type,
                manualEdit: true,
                data: content
              }
            };
          case 'dangerousHTML':
            return {
              type: 'DANGEROUS_HTML',
              mutability: 'IMMUTABLE',
              data: {
                html: content
              }
            };
          default:
            return null;
        }
      })();
      if (entityData == null) {
        return block;
      }
      blockSpec = _.extend({
        type: 'atomic',
        text: ' '
      }, {
        entityData: entityData
      });
      atomicBlock = gdtEditorUtils.createContentBlock(blockSpec);
      spacerBlock = gdtEditorUtils.createContentBlock();
      return contentBlocks.concat([atomicBlock, spacerBlock]);
    }, []);
    tempDoc = null;
    return ContentState.createFromBlockArray(contentBlocks);
  },
  removeInlineStyle: function(editorState, style) {
    var currentContent, currentSelection, newContentState;
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    newContentState = Modifier.removeInlineStyle(currentContent, currentSelection, style);
    return EditorState.push(editorState, newContentState);
  },
  updatedEntityData: function(entityKey, newData) {
    return Entity.mergeData(entityKey, newData);
  },
  getDecorators: function(customDecorators) {
    var defaultDecorators;
    if (customDecorators == null) {
      customDecorators = [];
    }
    defaultDecorators = [
      {
        strategy: gdtEditorUtils.findTextByEntityType('LINK'),
        component: Link
      }
    ];
    return new CompositeDecorator(defaultDecorators.concat(customDecorators));
  },
  getBlockStylesClassString: function(block) {
    var blockStyles;
    blockStyles = block.getIn(['data', 'styles'], Immutable.List());
    return blockStyles.reduce(function(result, blockStyle) {
      var blockStyleClass;
      blockStyleClass = CUSTOM_BLOCK_STYLES_CLASS_MAP[blockStyle];
      if (blockStyleClass != null) {
        return result.concat(blockStyleClass);
      } else {
        return result;
      }
    }, '');
  },
  toggleCustomBlockStyle: function(editorState, style) {
    var blockMap, currentContent, currentSelection, isAlignmentStyle, newContentState, selectedBlocks, updatedBlocks;
    currentContent = editorState.getCurrentContent();
    currentSelection = editorState.getSelection();
    blockMap = currentContent.getBlockMap();
    selectedBlocks = gdtEditorUtils.getSelectedBlocksList(editorState);
    isAlignmentStyle = /^TEXT_ALIGN/.test(style);
    updatedBlocks = Immutable.OrderedMap(selectedBlocks.map(function(block) {
      var blockKey, updatedBlockData;
      blockKey = block.get('key');
      updatedBlockData = block.update('data', Immutable.Map(), function(data) {
        return data.update('styles', Immutable.List(), function(styles) {
          var activeStyleIndex;
          if (isAlignmentStyle && styles.contains(style)) {
            return styles;
          }
          if (isAlignmentStyle) {
            activeStyleIndex = styles.findIndex(function(s) {
              return /^TEXT_ALIGN/.test(s);
            });
            return styles.set(activeStyleIndex, style);
          } else if (styles.contains(style)) {
            return styles.filterNot(function(s) {
              return s === style;
            });
          } else {
            return styles.push(style);
          }
        });
      });
      return [blockKey, updatedBlockData];
    }));
    newContentState = currentContent.merge({
      blockMap: blockMap.merge(updatedBlocks),
      selectionBefore: currentSelection,
      selectionAfter: currentSelection
    });
    return EditorState.push(editorState, newContentState);
  },
  numberToLetter: function(i) {
    var converted, digit, firstDigits, idx, inBase26, j, lastDigit;
    inBase26 = (i - 1).toString(26);
    firstDigits = 2 <= inBase26.length ? slice.call(inBase26, 0, j = inBase26.length - 1) : (j = 0, []), lastDigit = inBase26[j++];
    converted = (function() {
      var l, len, results;
      results = [];
      for (idx = l = 0, len = firstDigits.length; l < len; idx = ++l) {
        digit = firstDigits[idx];
        results.push(String.fromCharCode(96 + parseInt(digit, 26)));
      }
      return results;
    })();
    converted.push(String.fromCharCode(97 + parseInt(lastDigit, 26)));
    return converted.join('');
  }
};

module.exports = gdtEditorUtils;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var NewWindowIcon, OpenInNewWindowButton, React, func, ref, string;

React = __webpack_require__(0);

ref = __webpack_require__(1), func = ref.func, string = ref.string;

NewWindowIcon = __webpack_require__(27);

OpenInNewWindowButton = function(props) {
  return React.createElement("button", {
    "className": "inserted-table_button inserted-table_new-window-btn",
    "onClick": props.onClick,
    "onFocus": props.onFocus
  }, React.createElement(NewWindowIcon, {
    "className": "inserted-table-icon-svg"
  }), React.createElement("span", {
    "className": "button-label"
  }, props.label));
};

OpenInNewWindowButton.propTypes = {
  onClick: func.isRequired,
  onFocus: func,
  label: string.isRequired
};

OpenInNewWindowButton.defaultProps = {
  onFocus: function(e) {
    return e.stopPropagation();
  }
};

module.exports = OpenInNewWindowButton;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var CollapsedInsertedGdtTable, ExpandTableButton, OpenInNewWindowButton, React, TableMiniatureIcon, func, object, ref, string;

React = __webpack_require__(0);

ref = __webpack_require__(1), object = ref.object, string = ref.string, func = ref.func;

TableMiniatureIcon = __webpack_require__(25);

ExpandTableButton = __webpack_require__(10);

OpenInNewWindowButton = __webpack_require__(8);

CollapsedInsertedGdtTable = React.createClass({
  displayName: "CollapsedInsertedGdtTable",
  propTypes: {
    tableData: object.isRequired,
    outcomesText: string.isRequired,
    tableTitle: string.isRequired,
    onToggle: func.isRequired,
    openInNewWindow: func.isRequired,
    expandTitle: string.isRequired,
    openInNewWindowTitle: string.isRequired
  },
  render: function() {
    return React.createElement("div", null, React.createElement("div", {
      "className": "inserted-table_icon"
    }, React.createElement("span", {
      "className": "icon"
    }, React.createElement(TableMiniatureIcon, {
      "className": "inserted-table-icon-svg"
    })), React.createElement("span", {
      "className": "buttons"
    }, React.createElement(ExpandTableButton, {
      "onClick": this.props.onToggle,
      "label": this.props.expandTitle
    }), React.createElement(OpenInNewWindowButton, {
      "onClick": this.props.openInNewWindow,
      "label": this.props.openInNewWindowTitle
    }))), React.createElement("div", {
      "className": "inserted-table_title",
      "dangerouslySetInnerHTML": {
        __html: this.props.tableTitle
      }
    }), React.createElement("div", {
      "className": "inserted-table_outcomes"
    }, this.props.outcomesText));
  }
});

module.exports = CollapsedInsertedGdtTable;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var ExpandIcon, ExpandTableButton, React, func, ref, string;

React = __webpack_require__(0);

ref = __webpack_require__(1), func = ref.func, string = ref.string;

ExpandIcon = __webpack_require__(26);

ExpandTableButton = function(props) {
  return React.createElement("button", {
    "className": "inserted-table_button inserted-table_expand-btn",
    "onClick": props.onClick,
    "onFocus": props.onFocus
  }, React.createElement(ExpandIcon, {
    "className": "inserted-table-icon-svg"
  }), React.createElement("span", {
    "className": "button-label"
  }, props.label));
};

ExpandTableButton.propTypes = {
  onClick: func.isRequired,
  onFocus: func,
  label: string.isRequired
};

ExpandTableButton.defaultProps = {
  onFocus: function(e) {
    return e.stopPropagation();
  }
};

module.exports = ExpandTableButton;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var CollapseIcon, CollapseTableButton, React, func, ref, string;

React = __webpack_require__(0);

ref = __webpack_require__(1), func = ref.func, string = ref.string;

CollapseIcon = __webpack_require__(28);

CollapseTableButton = function(props) {
  return React.createElement("button", {
    "className": "inserted-table_button inserted-table_collapse-btn",
    "onClick": props.onClick,
    "onFocus": props.onFocus
  }, React.createElement(CollapseIcon, {
    "className": "inserted-table-icon-svg"
  }), React.createElement("span", {
    "className": "button-label"
  }, props.label));
};

CollapseTableButton.propTypes = {
  label: string.isRequired,
  onClick: func.isRequired,
  onFocus: func
};

CollapseTableButton.defaultProps = {
  onFocus: function(e) {
    return e.stopPropagation();
  }
};

module.exports = CollapseTableButton;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var DangerousContainer, Entity, React;

React = __webpack_require__(0);

Entity = __webpack_require__(3).Entity;

DangerousContainer = function(props) {
  var html;
  html = Entity.get(props.block.getEntityAt(0)).getData().html;
  return React.createElement("div", {
    "dangerouslySetInnerHTML": {
      __html: html
    }
  });
};

module.exports = DangerousContainer;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var DxEvidenceTable, OutcomeTable, React, _, greyBoldCell, greyCell, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

_ = __webpack_require__(2);

OutcomeTable = __webpack_require__(4);

greyCell = {
  backgroundColor: '#ebebeb',
  color: '#000'
};

greyBoldCell = _.extend({
  fontWeight: 'bold'
}, greyCell);

style = {
  bold: {
    fontWeight: 'bold'
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    margin: 'initial',
    borderCollapse: 'collapse',
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
  },
  cell: {
    border: '1px solid #bfbfbf'
  },
  thead: {
    fontSize: '8pt',
    backgroundColor: '#d2dfed'
  },
  thOutcome: {
    width: 'initial'
  },
  tdQuality: {
    textAlign: 'center'
  },
  tbody: {
    textAlign: 'left'
  },
  tdAbsDiff: greyCell,
  prevalencesDesc: greyCell,
  disabledImportance: greyCell,
  diagOutcomeAD: greyBoldCell
};

DxEvidenceTable = React.createClass({
  displayName: 'DxEvidenceTable',
  propTypes: {
    data: object.isRequired,
    style: object
  },
  render: function() {
    return React.createElement(OutcomeTable, {
      "data": this.props.data,
      "style": _.extend({}, style, this.props.style || {})
    });
  }
});

module.exports = DxEvidenceTable;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, Immutable, _, objectsEqual;

_ = __webpack_require__(2);

Immutable = __webpack_require__(6);

objectsEqual = function(objA, objB) {
  var aKey, aVal, bKey, bVal, keyValuesAreSame;
  if (!((objA != null) && (objB != null))) {
    return false;
  }
  if (objA === objB) {
    return true;
  }
  for (aKey in objA) {
    aVal = objA[aKey];
    if (objA.hasOwnProperty(aKey) && !objB.hasOwnProperty(aKey)) {
      return false;
    }
    bVal = objB[aKey];
    keyValuesAreSame = aVal === bVal ? true : Immutable.Iterable.isIterable(aVal) && Immutable.Iterable.isIterable(bVal) ? aVal.equals(bVal) : _.isObject(aVal) && _.isObject(bVal) ? objectsEqual(aVal, bVal) : false;
    if (!keyValuesAreSame) {
      return false;
    }
  }
  for (bKey in objB) {
    if (objB.hasOwnProperty(bKey) && !objA.hasOwnProperty(bKey)) {
      return false;
    }
  }
  return true;
};

CustomRenderMixin = {
  shouldComponentUpdate: function(nextProps, nextState) {
    return !objectsEqual(nextProps, this.props) || !objectsEqual(nextState, this.state);
  }
};

module.exports = CustomRenderMixin;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var AtomicBlockUtils, ContentState, DangerousContainer, Draft, Editor, EditorControls, EditorState, EmbeddedImageComponent, Entity, GdtEditor, Immutable, LinkInputModal, React, RichUtils, convertFromHTML, convertToRaw, editorUtils;

React = __webpack_require__(0);

Draft = __webpack_require__(3);

Immutable = __webpack_require__(6);

EditorControls = __webpack_require__(32);

EmbeddedImageComponent = __webpack_require__(18);

DangerousContainer = __webpack_require__(12);

LinkInputModal = __webpack_require__(33);

editorUtils = __webpack_require__(7);

Editor = Draft.Editor, EditorState = Draft.EditorState, ContentState = Draft.ContentState, Entity = Draft.Entity, RichUtils = Draft.RichUtils, AtomicBlockUtils = Draft.AtomicBlockUtils, convertToRaw = Draft.convertToRaw, convertFromHTML = Draft.convertFromHTML;

GdtEditor = React.createClass({
  displayName: 'Editor',
  propTypes: {
    readOnly: React.PropTypes.bool,
    editorContent: React.PropTypes.oneOfType([React.PropTypes.object, React.PropTypes.string]),
    attachments: React.PropTypes.instanceOf(Immutable.Map),
    saveAttachment: React.PropTypes.func,
    onFocus: React.PropTypes.func,
    onBlur: React.PropTypes.func,
    onChange: React.PropTypes.func,
    getEmbeddedImageSrc: React.PropTypes.func,
    controlsAutoHide: React.PropTypes.bool,
    stickControlsTo: React.PropTypes.string,
    customControls: React.PropTypes.arrayOf(React.PropTypes.object),
    customEntityRenderers: React.PropTypes.objectOf(React.PropTypes.func),
    customBlockRenderers: React.PropTypes.objectOf(React.PropTypes.func),
    customBlockMapEntries: React.PropTypes.objectOf(React.PropTypes.shape({
      element: React.PropTypes.string.isRequired,
      wrapper: React.PropTypes.element
    })),
    customHandlers: React.PropTypes.objectOf(React.PropTypes.func),
    customDecorators: React.PropTypes.oneOfType([
      React.PropTypes.shape({
        strategy: React.PropTypes.func.isRequired,
        component: React.PropTypes.func.isRequired,
        props: React.PropTypes.object
      }), React.PropTypes.arrayOf(React.PropTypes.shape({
        strategy: React.PropTypes.func.isRequired,
        component: React.PropTypes.func.isRequired,
        props: React.PropTypes.object
      }))
    ])
  },
  getInitialState: function() {
    return {
      editorState: editorUtils.getEditorState(this.props.editorContent, this.props.customDecorators),
      isEditing: false,
      keepEditorActive: false
    };
  },
  getDefaultProps: function() {
    return {
      customEntityRenderers: {},
      customBlockRenderers: {},
      customBlockMapEntries: {},
      customHandlers: {},
      controlsAutoHide: true,
      attachments: Immutable.Map()
    };
  },
  focus: function() {
    return this.editor.focus();
  },
  keepEditorActive: function() {
    return this.setState({
      keepEditorActive: true
    });
  },
  _onChange: function(editorState) {
    var base;
    this.setState({
      editorState: editorState
    });
    return typeof (base = this.props).onChange === "function" ? base.onChange(editorState) : void 0;
  },
  onEditorFocus: function() {
    var base;
    this.setState({
      isEditing: true,
      keepEditorActive: false
    });
    return typeof (base = this.props).onFocus === "function" ? base.onFocus() : void 0;
  },
  onEditorBlur: function(evt) {
    var base;
    if (!this.state.keepEditorActive) {
      this.setState({
        isEditing: false,
        keepEditorActive: false
      });
      return typeof (base = this.props).onBlur === "function" ? base.onBlur(evt) : void 0;
    }
  },
  getEmbeddedImageSrc: function(imageId) {
    var content_type, data, imageAttachment, ref;
    imageAttachment = this.props.attachments.get(imageId);
    if (!imageAttachment) {
      return null;
    }
    ref = imageAttachment.toJS(), content_type = ref.content_type, data = ref.data;
    return "data:" + content_type + ";base64," + data;
  },
  _insertAttachment: function(file) {
    var attachmentId;
    if (!/^image\//.test(file.type)) {
      return;
    }
    attachmentId = this.props.saveAttachment(file);
    return this.insertCustomBlock({
      type: 'IMAGE',
      mutability: 'IMMUTABLE',
      data: {
        imageId: attachmentId
      }
    });
  },
  insertCustomBlock: function(arg) {
    var data, editorState, entityKey, mutability, type;
    type = arg.type, mutability = arg.mutability, data = arg.data;
    editorState = this.state.editorState;
    entityKey = Entity.create(type, mutability, data);
    return this._onChange(AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' '));
  },
  insertText: function(text, entity) {
    var editorState;
    this.focus();
    editorState = this.state.editorState;
    return this._onChange(editorUtils.insertTextContent(editorState, text, entity));
  },
  _insertLink: function(url) {
    var editorState, entityKey;
    this.hideLinkInsert();
    this.focus();
    editorState = this.state.editorState;
    entityKey = Entity.create('LINK', 'MUTABLE', {
      url: url
    });
    return this._onChange(RichUtils.toggleLink(editorState, editorState.getSelection(), entityKey));
  },
  insertContent: function(params) {
    var content, contentBlocks, contentType, file;
    contentType = params.contentType, content = params.content, file = params.file;
    this.focus();
    switch (contentType) {
      case 'ATTACHMENT':
        return this._insertAttachment(file);
      case 'HTML':
        contentBlocks = editorUtils.html2content(content);
        return this._onChange(editorUtils.insertBlockContent(this.state.editorState, contentBlocks));
    }
  },
  updateEntityData: function(entityKey, newData) {
    this.focus();
    return editorUtils.updatedEntityData(entityKey, newData);
  },
  toggleStyle: function(params) {
    var style, type;
    type = params.type, style = params.style;
    switch (type) {
      case 'INLINE':
        return this.toggleInlineStyle(style);
      case 'BLOCK':
        return this.toggleBlockStyle(style);
      case 'LINK':
        return this.toggleLink();
    }
  },
  toggleLink: function() {
    var editorState;
    editorState = this.state.editorState;
    if (RichUtils.currentBlockContainsLink(editorState)) {
      return this._onChange(RichUtils.toggleLink(editorState, editorState.getSelection(), null));
    } else {
      return this.setState({
        showLinkInsert: true
      });
    }
  },
  toggleInlineStyle: function(style) {
    var activeFontStyle, activeStyle, editorState, isFontStyle;
    editorState = this.state.editorState;
    if (style === 'CLEAR_ALL') {
      return this._onChange(editorUtils.clearAllStyles(editorState));
    }
    activeStyle = editorState.getCurrentInlineStyle();
    isFontStyle = /_FONT$/.test(style);
    if (isFontStyle && activeStyle.has(style)) {
      return;
    }
    if (isFontStyle) {
      activeFontStyle = activeStyle.find(function(s) {
        return /_FONT$/.test(s);
      });
      if (activeFontStyle != null) {
        editorState = editorUtils.removeInlineStyle(editorState, activeFontStyle);
      }
    }
    return this._onChange(RichUtils.toggleInlineStyle(editorState, style));
  },
  toggleBlockStyle: function(style) {
    return this._onChange(style in editorUtils.CUSTOM_BLOCK_STYLES_CLASS_MAP ? editorUtils.toggleCustomBlockStyle(this.state.editorState, style) : RichUtils.toggleBlockType(this.state.editorState, style));
  },
  hideLinkInsert: function() {
    return this.setState({
      showLinkInsert: false
    }, this.focus);
  },
  blockRendererFn: function(block) {
    var blockType, entity, entityKey, entityType, getEmbeddedImageSrc, imageId, ref, renderFn;
    getEmbeddedImageSrc = (ref = this.props.getEmbeddedImageSrc) != null ? ref : this.getEmbeddedImageSrc;
    blockType = block.getType();
    if (blockType === 'atomic') {
      entityKey = block.getEntityAt(0);
      if (entityKey == null) {
        return;
      }
      entity = Entity.get(entityKey);
      entityType = entity.getType();
      if (entityType === 'IMAGE') {
        imageId = entity.getData().imageId;
        return {
          component: EmbeddedImageComponent,
          editable: false,
          props: {
            src: getEmbeddedImageSrc(imageId),
            imageId: imageId
          }
        };
      } else if (entityType === 'DANGEROUS_HTML') {
        return {
          component: DangerousContainer,
          editable: false
        };
      } else if (entityType in this.props.customEntityRenderers) {
        renderFn = this.props.customEntityRenderers[entityType];
        return renderFn(this, block);
      }
    } else if (blockType in this.props.customBlockRenderers) {
      renderFn = this.props.customBlockRenderers[blockType];
      return renderFn(this, block);
    }
  },
  blockStyleFn: editorUtils.getBlockStylesClassString,
  handleBeforeInput: function(chars) {
    var customHandler, editorState, newState;
    editorState = this.state.editorState;
    customHandler = this.props.customHandlers['handleBeforeInput'];
    if (customHandler != null) {
      newState = customHandler(editorState, chars);
      if (newState != null) {
        this._onChange(newState);
        return 'handled';
      }
    }
  },
  handleKeyCommand: function(command) {
    var customHandler, editorState, newState, withDeletedContent;
    editorState = this.state.editorState;
    customHandler = this.props.customHandlers['handleKeyCommand'];
    if (customHandler != null) {
      newState = customHandler(editorState, command);
      if (newState != null) {
        this._onChange(newState);
        return 'handled';
      } else {
        return 'not-handled';
      }
    } else {
      'not-handled';
    }
    if (command === 'split-block') {
      this._onChange(editorUtils.splitBlock(editorState));
      return 'handled';
    }
    if (command === 'backspace' || command === 'delete') {
      withDeletedContent = editorUtils.deleteContent(editorState, command);
      if (withDeletedContent) {
        this._onChange(withDeletedContent);
        return 'handled';
      }
    }
    return 'not-handled';
  },
  handlePastedText: function(text, html) {
    var convertedContent, customHandler, editorState, newState;
    editorState = this.state.editorState;
    customHandler = this.props.customHandlers['handlePastedText'];
    if (customHandler != null) {
      newState = customHandler(editorState, text, html);
      if (newState != null) {
        this._onChange(newState);
        return 'handled';
      }
    }
    if ((text != null) && (html == null)) {
      return 'not-handled';
    }
    convertedContent = editorUtils.html2content(html);
    this._onChange(editorUtils.insertBlockContent(editorState, convertedContent));
    return 'handled';
  },
  triggerBlocksRerender: function() {
    var currentSelection;
    currentSelection = this.state.editorState.getSelection();
    return this._onChange(EditorState.forceSelection(this.state.editorState, currentSelection.set('hasFocus', true)));
  },
  componentDidUpdate: function(prevProps, prevState) {
    if (!prevProps.attachments.equals(this.props.attachments)) {
      return this.triggerBlocksRerender();
    }
  },
  resetContent: function(content) {
    return this.setState({
      editorState: editorUtils.getEditorState(content, this.props.customDecorators),
      isEditing: false
    });
  },
  getEditorContent: function() {
    return Immutable.fromJS(convertToRaw(this.state.editorState.getCurrentContent()));
  },
  render: function() {
    var editorClasses;
    editorClasses = ['gdt-editor-container'];
    editorClasses = this.state.isEditing ? editorClasses.concat('editing') : this.props.readOnly ? editorClasses.concat('readonly') : editorClasses;
    return React.createElement("div", {
      "className": editorClasses.join(' ')
    }, (this.state.isEditing || !this.props.controlsAutoHide ? React.createElement("div", null, React.createElement(EditorControls, {
      "editorState": this.state.editorState,
      "customControls": this.props.customControls,
      "stickTo": this.props.stickControlsTo,
      "onToggle": this.toggleStyle
    })) : void 0), React.createElement(Editor, {
      "ref": ((function(_this) {
        return function(el) {
          return _this.editor = el;
        };
      })(this)),
      "readOnly": this.props.readOnly,
      "onChange": this._onChange,
      "onFocus": this.onEditorFocus,
      "onBlur": this.onEditorBlur,
      "editorState": this.state.editorState,
      "blockRenderMap": editorUtils.getBlockRenderMap(this.props.customBlockMapEntries),
      "blockRendererFn": this.blockRendererFn,
      "blockStyleFn": this.blockStyleFn,
      "customStyleMap": editorUtils.CUSTOM_STYLE_MAP,
      "handleBeforeInput": this.handleBeforeInput,
      "handlePastedText": this.handlePastedText,
      "handleKeyCommand": this.handleKeyCommand,
      "suppressContentEditableWarning": true
    }), (this.state.showLinkInsert ? React.createElement(LinkInputModal, {
      "onClose": this.hideLinkInsert,
      "onSubmit": this._insertLink
    }) : void 0));
  }
});

module.exports = GdtEditor;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var CustomRenderMixin, React, Tooltip;

React = __webpack_require__(0);

CustomRenderMixin = __webpack_require__(14);

Tooltip = React.createClass({
  displayName: 'TooltipWrapperComponent',
  mixins: [CustomRenderMixin],
  _elWithTooltip: function() {
    return $(this.refs.tooltipEl);
  },
  _initTooltips: function() {
    var ref;
    return (ref = this.props.mediator) != null ? ref.tooltips.info(this._elWithTooltip(), {
      cache: false
    }) : void 0;
  },
  _unmountTooltips: function() {
    var ref;
    return (ref = this.props.mediator) != null ? ref.tooltips.deactivateTooltip(this._elWithTooltip()) : void 0;
  },
  componentDidMount: function() {
    return this._initTooltips();
  },
  componentWillUpdate: function(nextProps, nextState) {
    return this._unmountTooltips();
  },
  componentDidUpdate: function(prevProps, prevState) {
    return this._initTooltips();
  },
  componentWillUnmount: function() {
    return this._unmountTooltips();
  },
  render: function() {
    return React.cloneElement(React.Children.only(this.props.children), {
      ref: 'tooltipEl'
    });
  }
});

module.exports = Tooltip;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var EmbeddedImageComponent, React;

React = __webpack_require__(0);

EmbeddedImageComponent = function(props) {
  var imageId, ref, src;
  ref = props.blockProps, src = ref.src, imageId = ref.imageId;
  if (!src) {
    return React.createElement("i", null, "Loading...");
  }
  return React.createElement("img", {
    "src": src,
    "style": {
      width: '100%'
    },
    "db-image": imageId,
    "is": true
  });
};

module.exports = EmbeddedImageComponent;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var LayerOneTwoSof, OutcomeTable, React, _, bold, left, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

_ = __webpack_require__(2);

bold = {
  fontWeight: 'bold'
};

left = {
  textAlign: 'left'
};

OutcomeTable = __webpack_require__(4);

style = {
  table: {
    width: '100%',
    border: '1px solid #bfbfbf',
    borderCollapse: 'collapse',
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
    padding: '5px'
  },
  thead: {
    backgroundColor: '#275C99',
    color: '#fff',
    borderTop: '2px solid #000',
    borderBottom: '2px solid #000',
    fontSize: '8pt'
  },
  cell: {
    border: '1px solid #bfbfbf'
  },
  thResultsPer1000: {
    backgroundColor: '#95B3D7',
    color: '#000',
    fontWeight: 'bold',
    borderBottom: '1px solid #000'
  },
  thQuality: bold,
  thNoOfParticipantsStudiesDiagnostic: bold,
  thTestResult: bold,
  thIndexTest: {
    backgroundColor: '#B8CCE4',
    color: '#000'
  },
  thComparatorTest: {
    backgroundColor: '#B8CCE4',
    color: '#000'
  },
  thPrevalence: {
    backgroundColor: '#B8CCE4',
    color: '#000',
    borderLeft: '1px solid #000',
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000'
  },
  tdPrevalence: {
    backgroundColor: '#DBE5F1'
  },
  tdPrevalenceTextCell: {
    textAlign: 'left',
    backgroundColor: '#DBE5F1'
  }
};

LayerOneTwoSof = React.createClass({
  displayName: 'LayerOneTwoSof',
  propTypes: {
    data: object.isRequired,
    style: object
  },
  render: function() {
    return React.createElement(OutcomeTable, {
      "data": this.props.data,
      "style": _.extend({}, style, this.props.style || {})
    });
  }
});

module.exports = LayerOneTwoSof;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var OutcomeTable, React, RelativeImportance, _, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

OutcomeTable = __webpack_require__(4);

_ = __webpack_require__(2);

style = {
  bold: {
    fontWeight: 'bold'
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    margin: 'initial',
    borderCollapse: 'collapse',
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
    textAlign: 'center'
  },
  cell: {
    border: '1px solid #bfbfbf'
  },
  thead: {
    fontSize: '8pt',
    backgroundColor: '#e9e9e9'
  }
};

RelativeImportance = React.createClass({
  displayName: 'RelativeImportance',
  propTypes: {
    data: object.isRequired,
    style: object
  },
  render: function() {
    return React.createElement(OutcomeTable, {
      "data": this.props.data,
      "style": _.extend({}, style, this.props.style || {})
    });
  }
});

module.exports = RelativeImportance;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var OutcomeTable, React, SofShortTable, _, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

_ = __webpack_require__(2);

OutcomeTable = __webpack_require__(4);

style = {
  bold: {
    fontWeight: 'bold'
  },
  table: {
    tableLayout: 'fixed',
    width: '100%',
    margin: 'initial',
    borderCollapse: 'collapse',
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif",
    textAlign: 'center'
  },
  cell: {
    border: '1px solid #bfbfbf'
  },
  thCell: {
    height: '75px'
  },
  thead: {
    fontSize: '8pt',
    backgroundColor: '#e9e9e9'
  },
  outcome: {
    width: '25%'
  }
};

SofShortTable = React.createClass({
  displayName: 'SofShortTable',
  propTypes: {
    data: object.isRequired,
    style: object
  },
  render: function() {
    return React.createElement(OutcomeTable, {
      "data": this.props.data,
      "style": _.extend({}, style, this.props.style || {})
    });
  }
});

module.exports = SofShortTable;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var OutcomeTable, React, SofTable, _, greyBoldCell, greyCell, object, style;

React = __webpack_require__(0);

object = __webpack_require__(1).object;

_ = __webpack_require__(2);

OutcomeTable = __webpack_require__(4);

greyCell = {
  backgroundColor: '#ebebeb',
  color: '#000'
};

greyBoldCell = _.extend({
  fontWeight: 'bold'
}, greyCell);

style = {
  table: {
    tableLayout: 'fixed',
    width: '100%',
    margin: 'initial',
    borderCollapse: 'collapse',
    borderTop: '2px solid black',
    borderBottom: '2px solid black',
    fontSize: '8pt',
    fontFamily: "Verdana, 'Arial Narrow', Arial, sans-serif"
  },
  thead: {
    backgroundColor: '#3271aa',
    color: '#fff',
    textAlign: 'left',
    verticalAlign: 'top',
    borderBottom: '2px solid black',
    fontSize: '8pt'
  },
  cell: {
    textAlign: 'left',
    verticalAlign: 'top',
    padding: '5px',
    fontSize: '8pt',
    border: '1px solid #bfbfbf'
  },
  absoluteEffect: greyBoldCell,
  without: greyBoldCell,
  "with": greyBoldCell,
  difference: greyBoldCell,
  riskWith: greyBoldCell,
  riksDifferenceWith: greyBoldCell,
  controlLabel: greyCell,
  dichCorrespondingRisk: greyCell,
  impact: greyCell,
  dichSofControl: greyCell,
  dichSofControlLow: greyCell,
  dichSofControlMedium: greyCell,
  dichSofControlHigh: greyCell,
  contSofControl: greyCell,
  contRiskDifference: greyCell,
  dichRiskDifference: greyCell,
  contCorrespondingRisk: greyCell
};

SofTable = React.createClass({
  displayName: 'SofTable',
  propTypes: {
    data: object.isRequired,
    style: object
  },
  render: function() {
    return React.createElement(OutcomeTable, {
      "data": this.props.data,
      "style": _.extend({}, style, this.props.style || {})
    });
  }
});

module.exports = SofTable;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var CollapseTableButton, CollapsedInsertedGdtTable, DangerousContainer, DxEvidenceTable, Editor, EditorUtils, EditorWithApply, EmbeddedImageComponent, ExpandTableButton, InsertedGdtTable, LayerOneTwoSof, OpenInNewWindowButton, OutcomeTable, ReferenceCitation, RelativeImportance, SofShort, SofTable, version;

version = __webpack_require__(24).version;

CollapsedInsertedGdtTable = __webpack_require__(9);

CollapseTableButton = __webpack_require__(11);

DangerousContainer = __webpack_require__(12);

DxEvidenceTable = __webpack_require__(13);

Editor = __webpack_require__(15);

EditorWithApply = __webpack_require__(35);

EditorUtils = __webpack_require__(7);

EmbeddedImageComponent = __webpack_require__(18);

ExpandTableButton = __webpack_require__(10);

InsertedGdtTable = __webpack_require__(38);

LayerOneTwoSof = __webpack_require__(19);

OutcomeTable = __webpack_require__(4);

OpenInNewWindowButton = __webpack_require__(8);

RelativeImportance = __webpack_require__(20);

SofShort = __webpack_require__(21);

SofTable = __webpack_require__(22);

ReferenceCitation = __webpack_require__(39);

__webpack_require__(40);

module.exports = {
  CollapsedInsertedGdtTable: CollapsedInsertedGdtTable,
  CollapseTableButton: CollapseTableButton,
  DangerousContainer: DangerousContainer,
  DxEvidenceTable: DxEvidenceTable,
  Editor: Editor,
  EditorWithApply: EditorWithApply,
  EditorUtils: EditorUtils,
  ExpandTableButton: ExpandTableButton,
  InsertedGdtTable: InsertedGdtTable,
  LayerOneTwoSof: LayerOneTwoSof,
  OutcomeTable: OutcomeTable,
  OpenInNewWindowButton: OpenInNewWindowButton,
  RelativeImportance: RelativeImportance,
  SofTable: SofTable,
  SofShort: SofShort,
  EmbeddedImageComponent: EmbeddedImageComponent,
  ReferenceCitation: ReferenceCitation,
  version: version
};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = {"name":"@ep/editor","version":"0.4.0","description":"Editor for gradepro application","main":"src/index.cjsx","scripts":{"build:prod":"NODE_ENV=production webpack","build:umd:prod":"NODE_ENV=production webpack --config scripts/umd.webpack.config","build:copy-files":"node ./scripts/copy-build-files.js","prebuild":"rm -rf ./dist","build":"yarn build:prod && yarn build:umd:prod && yarn build:copy-files","release":"yarn build && npm publish dist","start":"webpack --watch","test":"echo \"Error: no test specified\" && exit 1"},"author":"","license":"ISC","devDependencies":{"cjsx-loader":"^3.0.0","coffee-loader":"^0.7.2","coffee-script":"^1.12.2","css-loader":"^0.25.0","draft-js":"^0.10.5","extract-text-webpack-plugin":"^3.0.2","fs-extra":"^5.0.0","immutable":"^3.8.1","jsx-loader":"^0.13.2","prop-types":"^15.6.2","react":"^15.6.2","react-addons-create-fragment":"^15.6.2","style-loader":"^0.13.1","stylus":"^0.54.5","stylus-loader":"^2.3.1","svg-react-loader":"^0.4.5","underscore":"^1.9.1","underscore.string":"^3.3.4","webpack":"^3.10.0"},"peerDependencies":{"draft-js":"^0.10.5","prop-types":"*","react":"*","react-addons-create-fragment":"^15.6.2","underscore":"^1.9.1","underscore.string":"^3.3.4"}}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function TableMiniature (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".editorcls-1{isolation:isolate;}.editorcls-2{opacity:0.3;mix-blend-mode:multiply;}.editorcls-3{fill:#fff;}.editorcls-4{fill:none;stroke:#2990e2;stroke-miterlimit:10;}.editorcls-5{fill:#3271aa;}.editorcls-6{fill:#f2f2f2;}.editorcls-7{fill:#ddd;}")),React.createElement("title",{"key":1},"table minature"),React.createElement("g",{"className":"editorcls-1","key":2},React.createElement("g",{"id":"Layer_2","data-name":"Layer 2"},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("image",{"className":"editorcls-2","width":"109","height":"84","xlinkHref":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABUCAYAAACIjbkzAAAACXBIWXMAAAsSAAALEgHS3X78AAADPUlEQVR4Xu2dwW7TQBRFzyRpG9pSqAosEEgs+P+vQkCpKE1pQ0kam8WbF4+NU1jYVZ90jzSKYzubObrjcTY31XWNiMXkXzeIp8ds14WUUvLDXfeI0agB6h3LYOqez7ISlsJJPvYhxqXOo8qjxty1JLWkpZRc1BTYy2OWv0vcuLisDXAPrPLnBqhKcdvlMSdsgomaA4fAEfAsn3NxYng8YS5rCdzkz1VxHWg/0xImZg6cAK+As3w8x8QpbeNQY4laYbJ+AN/ytQrYpJSSp20Gf6XsCBP2AXgPvAGeAwdotzkWnrJb4BL4jIWjXCYrv7lMWintDBP2EXgLvMCkTRFjUGNyfgJf87nvWOKuaVa4JmnFyRnN8vgaE/YOOEXSxqTCpC3y9wVwDOzTs5foe6btYZuPEyxhp3nM0fI4FhXwOx9fY6vdAebHX7u2dKW5uBlm+SCPOXqmjYk/r/ZpXrPK9+QW3X9EyhfraTEmxRDjUM7xg7t0SQiIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSAiJpAZG0gEhaQCQtIJIWEEkLiKQFRNICImkBkbSASFpAJC0gkhYQSQuIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSAiJpAZG0gEhaQCQtIJIWEEkLiKQFRNICImkBkbSASFpAJC0gkhYQSQuIpAVE0gIiaQGRtIBIWkAkLSCSFhBJC4ikBUTSArJLWt0Z4nH4r3nvFgSVza+bniHGoW+uywbeFqW0sv11DdxhRaK/8gBLpjpBh8Xn3ed5ic39mkZeS1yftBXWTXmF9VMe5+vzfL+kDYv3gd5hlZKX2NzfYi52SvM1dI3ZXgDnWGMeWFflIZI2Bi5tiXWAfsLmfoG5WPNAZbIvizfABZYs76l8SSNNO85hqWikXQFfsPbdC8yFL5NbZmA98yklT9oSiyhYwjxxXuSqruvh8ARtsE5Qfyz5o2lJTlpvo3znxx7Zm/xj76rURmR4fC+xpmmT9w3gCnPSeqalQmBZUj7BhHqpaNkCK2nD4mnzZfIeE+iF5FWZMuhIg604aCSVsiRsHMoX6qr4pCsMeqS1LjYCJetxqKFfVMmD0sTT5A87WQB8KLDuEAAAAABJRU5ErkJggg==","key":0}),React.createElement("rect",{"className":"editorcls-3","x":"3.52","y":"4.42","width":"95.17","height":"69.62","rx":"1.86","ry":"1.86","key":1}),React.createElement("rect",{"className":"editorcls-4","x":"3.52","y":"4.42","width":"95.17","height":"69.62","rx":"1.86","ry":"1.86","key":2}),React.createElement("rect",{"className":"editorcls-5","x":"8.31","y":"14.82","width":"85.58","height":"4.72","key":3}),React.createElement("rect",{"className":"editorcls-5","x":"8.31","y":"33.44","width":"85.58","height":"4.72","key":4}),React.createElement("rect",{"className":"editorcls-6","x":"8.31","y":"20.89","width":"20.85","height":"11.46","key":5}),React.createElement("rect",{"className":"editorcls-7","x":"29.89","y":"20.89","width":"20.85","height":"11.46","key":6}),React.createElement("rect",{"className":"editorcls-7","x":"51.47","y":"20.89","width":"20.85","height":"11.46","key":7}),React.createElement("rect",{"className":"editorcls-6","x":"73.04","y":"20.89","width":"20.85","height":"11.46","key":8}),React.createElement("rect",{"className":"editorcls-5","x":"8.31","y":"51.69","width":"85.58","height":"4.72","key":9}),React.createElement("rect",{"className":"editorcls-6","x":"8.31","y":"57.76","width":"20.85","height":"11.46","key":10}),React.createElement("rect",{"className":"editorcls-7","x":"29.89","y":"57.76","width":"20.85","height":"11.46","key":11}),React.createElement("rect",{"className":"editorcls-7","x":"51.47","y":"57.76","width":"20.85","height":"11.46","key":12}),React.createElement("rect",{"className":"editorcls-6","x":"73.04","y":"57.76","width":"20.85","height":"11.46","key":13}),React.createElement("rect",{"className":"editorcls-6","x":"8.31","y":"39.32","width":"20.85","height":"11.46","key":14}),React.createElement("rect",{"className":"editorcls-7","x":"29.89","y":"39.32","width":"20.85","height":"11.46","key":15}),React.createElement("rect",{"className":"editorcls-7","x":"51.47","y":"39.32","width":"20.85","height":"11.46","key":16}),React.createElement("rect",{"className":"editorcls-6","x":"73.04","y":"39.32","width":"20.85","height":"11.46","key":17})])))]);
}

TableMiniature.displayName = "TableMiniature";

TableMiniature.defaultProps = {"viewBox":"0 0 109 84"};

module.exports = TableMiniature;

TableMiniature.default = TableMiniature;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function ExpandTable (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".editorcls-1{fill:#3783a5;}")),React.createElement("title",{"key":1},"expand"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"editorcls-1","d":"M12.09,8.93l-.89.89L8.35,7,11.2,4.13l.89.9a.66.66,0,0,0,1.11-.34L13.94.78A.65.65,0,0,0,13.18,0L9.27.76a.65.65,0,0,0-.34,1.1l.89.9L7,5.6,4.13,2.76l.9-.9A.65.65,0,0,0,4.69.76L.78,0A.66.66,0,0,0,0,.78L.76,4.69A.65.65,0,0,0,1.86,5l.9-.9L5.6,7,2.76,9.82l-.9-.89a.65.65,0,0,0-1.1.34L0,13.18a.65.65,0,0,0,.77.76l3.91-.74A.66.66,0,0,0,5,12.09l-.9-.89L7,8.35,9.82,11.2l-.89.89a.66.66,0,0,0,.34,1.11l3.91.74a.65.65,0,0,0,.76-.76L13.2,9.27A.66.66,0,0,0,12.09,8.93Z"})))]);
}

ExpandTable.displayName = "ExpandTable";

ExpandTable.defaultProps = {"viewBox":"0 0 13.96 13.96"};

module.exports = ExpandTable;

ExpandTable.default = ExpandTable;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function OpenInWindow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".editorcls-1{fill:#3783a5;}")),React.createElement("title",{"key":1},"open in window"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"editorcls-1","d":"M15.6,0,8.77.2a.55.55,0,0,0-.39.92l1.47,1.6L5.72,6.54,9,10.05,13.1,6.22l1.39,1.5a.55.55,0,0,0,.95-.32L16.16.61A.55.55,0,0,0,15.6,0Z","key":0}),React.createElement("path",{"className":"editorcls-1","d":"M13.4,12.3a1.16,1.16,0,0,1-1.16,1.16H2.33a1,1,0,0,1-1-1V3.2A1.25,1.25,0,0,1,2.56,2H6.64V.71H2.08A2.08,2.08,0,0,0,0,2.79v9.83A2.08,2.08,0,0,0,2.08,14.7H12.62a2.08,2.08,0,0,0,2.08-2.08V9.9H13.4Z","key":1})]))]);
}

OpenInWindow.displayName = "OpenInWindow";

OpenInWindow.defaultProps = {"viewBox":"0 0 16.16 14.7"};

module.exports = OpenInWindow;

OpenInWindow.default = OpenInWindow;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);

function CollapseTable (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".editorcls-1{fill:#3783a5;}")),React.createElement("title",{"key":1},"collapse"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("path",{"className":"editorcls-1","d":"M15.36,6a0,0,0,0,0,0-.06L13.66,4.22l2.85-2.85L15.13,0,12.29,2.85,10.57,1.12a0,0,0,0,0-.07,0l-1.13,6a0,0,0,0,0,0,0Z","key":0}),React.createElement("path",{"className":"editorcls-1","d":"M1.14,11a0,0,0,0,0,0,.06L2.85,12.8,0,15.65,1.37,17l2.85-2.85,1.72,1.72a0,0,0,0,0,.06,0L7.14,9.93a0,0,0,0,0,0,0Z","key":1}),React.createElement("path",{"className":"editorcls-1","d":"M15.38,11.08a0,0,0,0,0,0-.06L9.41,9.88a0,0,0,0,0,0,0l1.13,5.94a0,0,0,0,0,.07,0l1.72-1.72L15.13,17l1.38-1.37L13.66,12.8Z","key":2}),React.createElement("path",{"className":"editorcls-1","d":"M5.94,1.12,4.22,2.85,1.37,0,0,1.37,2.85,4.22,1.12,5.94a0,0,0,0,0,0,.06l6,1.14a0,0,0,0,0,0,0L6,1.14A0,0,0,0,0,5.94,1.12Z","key":3})]))]);
}

CollapseTable.displayName = "CollapseTable";

CollapseTable.defaultProps = {"viewBox":"0 0 16.51 17.02"};

module.exports = CollapseTable;

CollapseTable.default = CollapseTable;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = require("underscore.string");

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = require("react-addons-create-fragment");

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var Entity, Link, React;

React = __webpack_require__(0);

Entity = __webpack_require__(3).Entity;

Link = function(props) {
  var url;
  url = Entity.get(props.entityKey).getData().url;
  return React.createElement("a", {
    "href": url,
    "style": {
      cursor: 'pointer',
      textDecoration: 'none'
    }
  }, props.children);
};

module.exports = Link;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var CONTROL_TYPES, GdtEditorControls, Immutable, NestedStyleControl, React, STYLES_CONTROLS, STYLES_CONTROLS_ORDER, StyleControl, Tooltip, Translation, arrayOf, classNames, func, oneOf, ref, shape, string;

React = __webpack_require__(0);

Immutable = __webpack_require__(6);

ref = __webpack_require__(1), func = ref.func, oneOf = ref.oneOf, string = ref.string, arrayOf = ref.arrayOf, shape = ref.shape;

classNames = __webpack_require__(16);

Tooltip = __webpack_require__(17);

Translation = __webpack_require__(5);

STYLES_CONTROLS_ORDER = ['IN_BOLD', 'IN_ITAL', 'IN_UNDER', 'IN_FSIZE', 'BL_UL', 'BL_ALIGN', 'LINK', 'CUSTOM', 'IN_CLEARF'];

CONTROL_TYPES = ['INLINE', 'BLOCK', 'LINK'];

STYLES_CONTROLS = {
  'IN_BOLD': {
    label: 'bold',
    style: 'BOLD',
    type: 'INLINE',
    hasIcon: true
  },
  'IN_ITAL': {
    label: 'italic',
    style: 'ITALIC',
    type: 'INLINE',
    hasIcon: true
  },
  'IN_UNDER': {
    label: 'underline',
    style: 'UNDERLINE',
    type: 'INLINE',
    hasIcon: true
  },
  'IN_FSIZE': {
    label: 'fsize',
    subControls: ['IN_FSIZE_SMALL', 'IN_FSIZE_MODERATE', 'IN_FSIZE_NORM', 'IN_FSIZE_LRG', 'IN_FSIZE_HUGE'],
    type: 'INLINE',
    hasIcon: true
  },
  'IN_FSIZE_SMALL': {
    label: 'small',
    style: 'SMALL_FONT',
    type: 'INLINE'
  },
  'IN_FSIZE_MODERATE': {
    label: 'moderate',
    style: 'MODERATE_FONT',
    type: 'INLINE'
  },
  'IN_FSIZE_NORM': {
    label: 'normal',
    style: 'NORMAL_FONT',
    type: 'INLINE'
  },
  'IN_FSIZE_LRG': {
    label: 'large',
    style: 'LARGE_FONT',
    type: 'INLINE'
  },
  'IN_FSIZE_HUGE': {
    label: 'huge',
    style: 'HUGE_FONT',
    type: 'INLINE'
  },
  'IN_CLEARF': {
    label: 'clearformat',
    style: 'CLEAR_ALL',
    type: 'INLINE',
    hasIcon: true
  },
  'LINK': {
    label: 'link',
    style: 'LINK',
    type: 'LINK',
    hasIcon: true
  },
  'BL_UL': {
    label: 'ul',
    style: 'unordered-list-item',
    type: 'BLOCK'
  },
  'BL_ALIGN': {
    label: 'align',
    type: 'BLOCK',
    subControls: ['BL_ALIGN_LT', 'BL_ALIGN_CNTR', 'BL_ALIGN_RT'],
    hasIcon: true
  },
  'BL_ALIGN_LT': {
    label: 'left',
    style: 'TEXT_ALIGN_LEFT',
    type: 'BLOCK',
    hasIcon: true
  },
  'BL_ALIGN_CNTR': {
    label: 'center',
    style: 'TEXT_ALIGN_CENTER',
    type: 'BLOCK',
    hasIcon: true
  },
  'BL_ALIGN_RT': {
    label: 'right',
    style: 'TEXT_ALIGN_RIGHT',
    type: 'BLOCK',
    hasIcon: true
  }
};

StyleControl = React.createClass({
  displayName: 'StyleControl',
  propTypes: {
    onToggle: func.isRequired,
    type: oneOf(CONTROL_TYPES),
    label: string.isRequired,
    style: string
  },
  mixins: [Translation('editor')],
  handleMouseDown: function(e) {
    var ref1, style, type;
    e.preventDefault();
    ref1 = this.props, type = ref1.type, style = ref1.style;
    return this.props.onToggle({
      type: type,
      style: style
    });
  },
  render: function() {
    var hasIcon, isActive, label, ref1, spanClass;
    ref1 = this.props, isActive = ref1.isActive, hasIcon = ref1.hasIcon, label = ref1.label;
    spanClass = classNames('style-control', {
      icon: hasIcon,
      active: isActive
    });
    return React.createElement(Tooltip, null, React.createElement("div", {
      "className": spanClass,
      "onMouseDown": this.handleMouseDown,
      "title": this.i18n("tooltips." + label)
    }, React.createElement("span", {
      "className": label
    }, (!hasIcon ? this.i18n("labels." + label) : void 0))));
  }
});

NestedStyleControl = React.createClass({
  displayName: 'NestedStyleControl',
  propTypes: {
    label: string.isRequired,
    type: oneOf(CONTROL_TYPES),
    subControls: arrayOf(shape({
      label: string.isRequired,
      style: string,
      type: oneOf(CONTROL_TYPES)
    })),
    onToggle: func.isRequired
  },
  mixins: [Translation('editor')],
  getInitialState: function() {
    return {
      showNested: false
    };
  },
  handleMouseDown: function(e) {
    e.preventDefault();
    if (this.props.isExpanded) {
      return this.props.collapseNestedControls();
    } else {
      return this.props.expandNestedControls();
    }
  },
  handleControlToggle: function(data) {
    return this.props.onToggle(data);
  },
  _isSubControlActive: function(spec) {
    return this.props.activeStyle.has(spec.style);
  },
  renderNestedControls: function() {
    return React.createElement("div", null, this.props.subControls.map((function(_this) {
      return function(spec, idx) {
        var hasIcon, label, style, type;
        label = spec.label, style = spec.style, type = spec.type, hasIcon = spec.hasIcon;
        return React.createElement(StyleControl, Object.assign({}, spec, {
          "key": idx,
          "onToggle": _this.handleControlToggle,
          "isActive": _this._isSubControlActive(spec)
        }));
      };
    })(this)));
  },
  render: function() {
    var classes, hasIcon, isExpanded, label, ref1;
    ref1 = this.props, label = ref1.label, hasIcon = ref1.hasIcon, isExpanded = ref1.isExpanded;
    classes = classNames('style-control with-nested', {
      active: this.state.showControls
    });
    return React.createElement("div", {
      "className": classes,
      "onMouseDown": this.handleMouseDown,
      "style": {
        display: 'inline-block'
      }
    }, React.createElement(Tooltip, null, React.createElement("span", {
      "className": label,
      "title": this.i18n("tooltips." + label)
    }, (!hasIcon ? this.i18n("labels." + label) : void 0))), (isExpanded ? React.createElement("div", {
      "className": 'sub-controls'
    }, this.renderNestedControls()) : void 0));
  }
});

GdtEditorControls = React.createClass({
  displayName: 'GdtEditorControls',
  propTypes: {
    stickTo: string,
    customControls: arrayOf(shape({
      label: string.isRequired,
      onToggle: func.isRequired
    }))
  },
  getInitialState: function() {
    return {
      expandedNestedControls: null
    };
  },
  expandNestedControls: function(controlsLabel) {
    return (function(_this) {
      return function() {
        return _this.setState({
          expandedNestedControls: controlsLabel
        });
      };
    })(this);
  },
  collapseNestedControls: function() {
    return this.setState({
      expandedNestedControls: null
    });
  },
  onToggle: function(data) {
    this.setState({
      expandedNestedControls: null
    });
    return this.props.onToggle(data);
  },
  _onContainerScroll: function(ev) {
    var componentNode, containerTop, initialTop, ref1;
    ref1 = this, containerTop = ref1.containerTop, initialTop = ref1.initialTop;
    componentNode = ReactDOM.findDOMNode(this);
    if (initialTop < containerTop + this.container.scrollTop) {
      componentNode.style.position = 'fixed';
      return componentNode.style.top = containerTop + "px";
    } else {
      componentNode.style.position = '';
      return componentNode.style.top = '';
    }
  },
  componentDidMount: function() {
    if (this.props.stickTo != null) {
      this.container = document.querySelector(this.props.stickTo);
    }
    if (!this.container) {
      return;
    }
    this.containerTop = this.container.getBoundingClientRect().top;
    this.initialTop = ReactDOM.findDOMNode(this).getBoundingClientRect().top + this.container.scrollTop;
    this.container.addEventListener('scroll', this._onContainerScroll);
    return this._onContainerScroll();
  },
  componentWillUnmount: function() {
    if (!this.container) {
      return;
    }
    this.container.removeEventListener('scroll', this._onContainerScroll);
    this.container = null;
    this.containerTop = null;
    return this.initialTop = null;
  },
  renderBlockStyleControl: function(spec, idx) {
    var activeBlockType, activeStyle, currentSelection, hasIcon, label, ref1, style, subControls, subControlsSpecs, type;
    label = spec.label, style = spec.style, subControls = spec.subControls, type = spec.type, hasIcon = spec.hasIcon;
    activeStyle = type === 'INLINE' ? (ref1 = this.props.editorState) != null ? ref1.getCurrentInlineStyle() : void 0 : (currentSelection = this.props.editorState.getSelection(), activeBlockType = this.props.editorState.getCurrentContent().getBlockForKey(currentSelection.getStartKey()).getType(), Immutable.Set([activeBlockType]));
    if (subControls) {
      subControlsSpecs = subControls.map(function(controlId) {
        return STYLES_CONTROLS[controlId];
      });
      return React.createElement(NestedStyleControl, {
        "key": idx + "-in",
        "label": label,
        "hasIcon": hasIcon,
        "subControls": subControlsSpecs,
        "onToggle": this.onToggle,
        "expandNestedControls": this.expandNestedControls(label),
        "collapseNestedControls": this.collapseNestedControls,
        "isExpanded": this.state.expandedNestedControls === label,
        "activeStyle": activeStyle
      });
    } else {
      return React.createElement(StyleControl, Object.assign({}, spec, {
        "key": idx,
        "onToggle": this.onToggle,
        "isActive": activeStyle.has(style)
      }));
    }
  },
  renderCustomControls: function() {
    if (!this.props.customControls) {
      return false;
    }
    return this.props.customControls.map(function(controlSpec, idx) {
      return React.createElement(StyleControl, Object.assign({}, controlSpec, {
        "key": idx
      }));
    });
  },
  render: function() {
    return React.createElement("div", {
      "className": 'style-controls-container'
    }, STYLES_CONTROLS_ORDER.map((function(_this) {
      return function(id, idx) {
        var controlSpec;
        if (id === 'CUSTOM') {
          return _this.renderCustomControls();
        }
        controlSpec = STYLES_CONTROLS[id];
        if (!controlSpec) {
          return null;
        }
        return _this.renderBlockStyleControl(controlSpec, idx);
      };
    })(this)));
  }
});

module.exports = GdtEditorControls;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var LinkInputModal, Modal, React, Translation, styles;

React = __webpack_require__(0);

Modal = __webpack_require__(34);

Translation = __webpack_require__(5);

styles = {
  modal: {
    content: {
      top: '40vh',
      bottom: 'initial',
      width: '400px',
      backgroundColor: '#fff'
    }
  },
  button: {
    backgroundColor: '#009cca',
    color: '#fff',
    lineHeight: '30px',
    marginLeft: '10px',
    width: '100px'
  },
  input: {
    width: '220px',
    fontSize: '16px',
    lineHeight: '30px'
  }
};

LinkInputModal = React.createClass({
  displayName: 'LinkInputModal',
  mixins: [Translation('')],
  onSubmit: function() {
    var link;
    link = this.input.value;
    return this.props.onSubmit(link);
  },
  render: function() {
    var button, input, modal;
    modal = styles.modal, button = styles.button, input = styles.input;
    return React.createElement(Modal, {
      "style": modal,
      "contentLabel": "",
      "onClose": this.props.onClose,
      "isOpen": true,
      "closeButton": true
    }, React.createElement("div", null, React.createElement("input", {
      "ref": ((function(_this) {
        return function(el) {
          return _this.input = el;
        };
      })(this)),
      "style": input,
      "placeholder": 'Link...',
      "autoFocus": true
    }), React.createElement("button", {
      "style": button,
      "onClick": this.onSubmit
    }, this.i18n('actions.save'))));
  }
});

module.exports = LinkInputModal;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Modal, React, _, bool, func, modalStyle, ref;

React = __webpack_require__(0);

ref = __webpack_require__(1), bool = ref.bool, func = ref.func;

_ = __webpack_require__(2);

modalStyle = {
  content: {
    top: null,
    left: null,
    right: null,
    bottom: null,
    border: null,
    background: null,
    borderRadius: null,
    padding: null,
    position: null,
    overflow: null
  },
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.85)'
  }
};

Modal = React.createClass({
  displayName: 'Modal',
  propTypes: {
    isOpen: bool.isRequired,
    onClose: func,
    closeButton: bool
  },
  render: function() {
    var ref1;
    ReactModal.setAppElement(document.body);
    return React.createElement(ReactModal, Object.assign({}, this.props, {
      "className": this.props.className,
      "style": _.extend({}, modalStyle, this.props.style),
      "contentLabel": (ref1 = this.props.contentLabel) != null ? ref1 : "",
      "isOpen": this.props.isOpen
    }), (this.props.title ? React.createElement("h2", null, this.props.title) : void 0), (this.props.closeButton ? React.createElement("div", {
      "className": "modal-close",
      "onClick": this.props.onClose
    }) : void 0), this.props.children);
  }
});

module.exports = Modal;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var ApplyCancelButtons, Editor, EditorWithApply, React, Translation;

React = __webpack_require__(0);

Editor = __webpack_require__(15);

ApplyCancelButtons = __webpack_require__(36);

Translation = __webpack_require__(5);

EditorWithApply = React.createClass({
  displayName: 'EditorWithApply',
  mixins: [Translation('')],
  getInitialState: function() {
    return {
      showCancelApply: false
    };
  },
  showCancelApply: function() {
    return this.setState({
      showCancelApply: true
    });
  },
  hideCancelApply: function() {
    return this.setState({
      showCancelApply: false
    });
  },
  onFocus: function() {
    var base;
    if (typeof (base = this.props).onFocus === "function") {
      base.onFocus();
    }
    return this.showCancelApply();
  },
  onBlur: function(evt) {
    var base;
    if (typeof (base = this.props).onBlur === "function") {
      base.onBlur(evt);
    }
    return this.hideCancelApply();
  },
  onCancel: function() {
    var base;
    if (typeof (base = this.props).onCancel === "function") {
      base.onCancel();
    }
    return this.hideCancelApply();
  },
  onApply: function() {
    var base;
    if (typeof (base = this.props).onApply === "function") {
      base.onApply();
    }
    return this.hideCancelApply();
  },
  render: function() {
    return React.createElement("div", null, React.createElement(Editor, Object.assign({}, this.props, {
      "ref": ((function(_this) {
        return function(el) {
          return _this.gdtEditor = el;
        };
      })(this)),
      "onFocus": this.onFocus,
      "onBlur": this.onBlur
    })), (this.state.showCancelApply ? React.createElement(ApplyCancelButtons, {
      "onCancel": this.onCancel,
      "onApply": this.onApply
    }) : void 0));
  }
});

module.exports = EditorWithApply;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var ApplyCancelButtons, Button, React, Translation, func;

React = __webpack_require__(0);

func = __webpack_require__(1).func;

Button = __webpack_require__(37);

Translation = __webpack_require__(5);

ApplyCancelButtons = React.createClass({
  displayName: 'ApplyCancelButtons',
  propTypes: {
    onApply: func,
    onCancel: func
  },
  mixins: [Translation('')],
  render: function() {
    return React.createElement("div", {
      "className": "row buttons-react"
    }, React.createElement("div", {
      "className": "col-6"
    }, React.createElement(Button, {
      "className": "cancel btn btn-block",
      "label": this.i18n('actions.cancel'),
      "onMouseDown": this.props.onCancel
    })), React.createElement("div", {
      "className": "col-6"
    }, React.createElement(Button, {
      "className": "apply btn btn-block btn-success",
      "label": this.i18n('actions.apply'),
      "onMouseDown": this.props.onApply
    })));
  }
});

module.exports = ApplyCancelButtons;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var Button, React, Tooltip;

React = __webpack_require__(0);

Tooltip = __webpack_require__(17);

Button = React.createClass({
  displayName: 'Button',
  render: function() {
    return React.createElement(Tooltip, null, React.createElement("button", Object.assign({}, this.props), this.props.label));
  }
});

module.exports = Button;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var CollapseTableButton, CollapsedInsertedGdtTable, DxEvidenceTable, EditorUtils, Entity, InsertedGdtTable, LayerOneTwoSof, OpenInNewWindowButton, React, RelativeImportance, SofShort, SofTable, Translation, classNames;

React = __webpack_require__(0);

classNames = __webpack_require__(16);

Entity = __webpack_require__(3).Entity;

CollapsedInsertedGdtTable = __webpack_require__(9);

CollapseTableButton = __webpack_require__(11);

DxEvidenceTable = __webpack_require__(13);

EditorUtils = __webpack_require__(7);

LayerOneTwoSof = __webpack_require__(19);

OpenInNewWindowButton = __webpack_require__(8);

RelativeImportance = __webpack_require__(20);

SofShort = __webpack_require__(21);

SofTable = __webpack_require__(22);

Translation = __webpack_require__(5);

InsertedGdtTable = React.createClass({
  displayName: "InsertedGdtTable",
  mixins: [Translation('')],
  getInitialState: function() {
    return {
      expanded: true
    };
  },
  _getEntityKey: function() {
    return this.props.block.getEntityAt(0);
  },
  _getTableProps: function() {
    return Entity.get(this._getEntityKey()).getData();
  },
  renderTable: function() {
    var data, htmlTable, manualEdit, ref, type;
    ref = this._getTableProps(), type = ref.type, data = ref.data, manualEdit = ref.manualEdit;
    if (manualEdit) {
      htmlTable = typeof data === 'string' ? data : data.html;
      return React.createElement("div", {
        "className": 'embedded',
        "dangerouslySetInnerHTML": {
          __html: htmlTable
        }
      });
    }
    switch (type) {
      case 'l1_sof':
      case 'l2_sof':
        return React.createElement(LayerOneTwoSof, {
          "type": type,
          "data": data,
          "tableOnly": true
        });
      case 'evidence_short':
        return React.createElement(DxEvidenceTable, {
          "data": data
        });
      case 'relative_importance':
        return React.createElement(RelativeImportance, {
          "data": data
        });
      case 'sof_short':
        return React.createElement(SofShort, {
          "data": data
        });
      case 'sof_v1':
      case 'sof_v2':
      case 'sof_v3':
        return React.createElement(SofTable, {
          "data": data
        });
      default:
        return false;
    }
  },
  openTableInNewWindow: function() {
    var data;
    data = this._getTableProps().data;
    return EditorUtils.openTableInNewWindow(data.title, ReactDOM.findDOMNode(this.tableContent).innerHTML);
  },
  toggleTable: function(e) {
    e.stopPropagation();
    return this.setState({
      expanded: !this.state.expanded
    });
  },
  collapsedTable: function() {
    var data, outcomesSize, outcomesText, ref, ref1, tableTitle;
    data = this._getTableProps().data;
    tableTitle = (this.i18n('editor.table')) + ": <b>" + data.title + "</b>";
    outcomesText = outcomesSize === 1 ? this.i18n('editor.outcome') : this.i18n('editor.outcomes');
    outcomesSize = (ref = (ref1 = data.outcomes) != null ? ref1.length : void 0) != null ? ref : 0;
    return React.createElement(CollapsedInsertedGdtTable, {
      "tableData": data,
      "tableTitle": tableTitle,
      "outcomesText": outcomesText + " " + outcomesSize,
      "onToggle": this.toggleTable,
      "openInNewWindow": this.openTableInNewWindow,
      "expandTitle": this.i18n('editor.expand_table'),
      "openInNewWindowTitle": this.i18n('editor.open_table_in_new_window')
    });
  },
  render: function() {
    return React.createElement("div", null, this.state.expanded && React.createElement("div", {
      "className": "inserted-table_buttons-row"
    }, React.createElement(CollapseTableButton, {
      "label": this.i18n('editor.collapse_table'),
      "onClick": this.toggleTable
    }), React.createElement(OpenInNewWindowButton, {
      "label": this.i18n('editor.open_table_in_new_window'),
      "onClick": this.openTableInNewWindow
    })), React.createElement("div", {
      "ref": ((function(_this) {
        return function(el) {
          return _this.tableContent = el;
        };
      })(this)),
      "className": classNames({
        'hidden': !this.state.expanded
      })
    }, this.renderTable()), !this.state.expanded && this.collapsedTable());
  }
});

module.exports = InsertedGdtTable;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var Entity, Immutable, React, ReferenceCitation, _;

React = __webpack_require__(0);

Immutable = __webpack_require__(6);

Entity = __webpack_require__(3).Entity;

_ = __webpack_require__(2);

ReferenceCitation = React.createClass({
  displayName: 'ReferenceCitation',
  _refToString: function(ref) {
    var authors, ref1, refAuthor, year;
    authors = ref.get('authors');
    year = (ref1 = ref.get('year').match(/\d{4}/)) != null ? ref1[0] : void 0;
    refAuthor = authors.first().get('lastName');
    if (authors.size > 1) {
      refAuthor = refAuthor + " et al.";
    }
    return refAuthor + ", " + year;
  },
  getDeduplicatedReferences: function() {
    if (!this.props.references) {
      return new Immutable.List();
    }
    return this.props.references.filterNot(function(ref) {
      return ref.get('deduplicationStatus') === 'merged';
    });
  },
  getReferenceByIds: function(refIds) {
    var deduplicatedReferences;
    refIds = [].concat(refIds);
    deduplicatedReferences = this.getDeduplicatedReferences();
    return Immutable.List(refIds).map(function(refId) {
      return deduplicatedReferences.find(function(ref) {
        return ref.get('_id') === refId;
      });
    });
  },
  getReferences: function() {
    var ref, refIds;
    refIds = Entity.get(this.props.entityKey).getData().refIds;
    return ref = this.getReferenceByIds(refIds).filter(function(r) {
      return r !== void 0;
    }).interpose(', ');
  },
  render: function() {
    var references;
    references = this.getReferences();
    if (references.isEmpty()) {
      return false;
    }
    return React.createElement("span", {
      "style": {
        backgroundColor: '#ebebeb'
      }
    }, React.createElement("span", null, "("), references.map((function(_this) {
      return function(ref, idx) {
        if (!ref) {
          return "";
        }
        if (_.isString(ref)) {
          return React.createElement("span", {
            "key": idx
          }, ref);
        } else {
          return React.createElement("span", {
            "key": idx,
            "data-refid": ref.get('_id')
          }, _this._refToString(ref));
        }
      };
    })(this)), this.props.children);
  }
});

module.exports = ReferenceCitation;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ep/editor/index.js
// module id = 367
// module chunks = 168707334958949